import MediaActionTypes from "./media.types";

const INITIAL_STATE = { error: null };

const getMediaItems = (jobMedia) => (Array.isArray(jobMedia) ? jobMedia : jobMedia?.items || []);

const mediaReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MediaActionTypes.SET_MEDIA_FOR_JOB:
      return {
        ...state,
        [action.payload.jobid]: {
          items: Array.isArray(action.payload.media) ? action.payload.media : action.payload.media?.items || [],
          mediaTags: action.payload.mediaTags || action.payload.media?.mediaTags || []
        }
      };
    case MediaActionTypes.GET_MEDIA_FOR_JOB_ERROR:
      return { ...state, error: action.payload };
    case MediaActionTypes.ADD_MEDIA_FOR_JOB:
      return {
        ...state,
        [action.payload.jobid]: {
          items: [...getMediaItems(state[action.payload.jobid]), ...(action.payload.media || [])],
          mediaTags: state[action.payload.jobid]?.mediaTags || []
        }
      };
    case MediaActionTypes.TOGGLE_MEDIA_SELECTED:
      return {
        ...state,
        [action.payload.jobid]: {
          ...state[action.payload.jobid],
          items: getMediaItems(state[action.payload.jobid]).map((p) => {
            const matches = action.payload.relativePath
              ? p.relativePath === action.payload.relativePath
              : p.filename === action.payload.filename;
            return matches ? { ...p, isSelected: !p.isSelected } : p;
          })
        }
      };
    case MediaActionTypes.SELECT_ALL_MEDIA_FOR_JOB:
      return {
        ...state,
        [action.payload.jobid]: {
          ...state[action.payload.jobid],
          items: getMediaItems(state[action.payload.jobid]).map((p) => ({ ...p, isSelected: true }))
        }
      };
    case MediaActionTypes.SELECT_MEDIA_TYPE_FOR_JOB:
      return {
        ...state,
        [action.payload.jobid]: {
          ...state[action.payload.jobid],
          items: getMediaItems(state[action.payload.jobid]).map((p) => {
            const isImage = p.type?.mime?.startsWith("image") === true;
            const matches = action.payload.mediaType === "images" ? isImage : !isImage;
            return { ...p, isSelected: matches };
          })
        }
      };
    case MediaActionTypes.DESELECT_ALL_MEDIA_FOR_JOB:
      return {
        ...state,
        [action.payload.jobid]: {
          ...state[action.payload.jobid],
          items: getMediaItems(state[action.payload.jobid]).map((p) => ({ ...p, isSelected: false }))
        }
      };
    default:
      return state;
  }
};

export default mediaReducer;
